import { render } from "./FeedbackTwo.vue?vue&type=template&id=0a9d5fc7"
import script from "./FeedbackTwo.vue?vue&type=script&lang=js"
export * from "./FeedbackTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__